module.exports = __webpack_public_path__ + "img/bg.86816efa.png";